"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(className, styles) {
  if (!styles[className]) {
    throw new Error("Could not resolve the styleName ".concat(className));
  }

  return styles[className];
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/functions/classNameToStyleName.js
// module id = 338
// module chunks = 168707334958949